module.exports = "../study/imgs/maps/Nagano/S8/Helth/HeatStress/Nagano_HeatStress_MIROC5_RCP26_Mid.png";